import React, {Component, ReactElement, ReactNode} from 'react'
import NatCurrentDateTimeRepo from '../currentDateTime/repository/NatCurrentDateTimeRepo'
import {HOURS, MESSAGE_TYPE, MINUTS} from '../../../CodeMaster'
import {AdminPagePropsSet, createAdminPage} from '../../../components/shared/hoc/createAdminPage'
import {Nullable} from '../../../app/TypeHelpers'
import {NatGetCurrentDateTime} from '../currentDateTime/repository/NatGetCurrentDateTime'
import {Messages} from '../../../Messages'
import {
    PageFooterArea,
    PageFotterAreaLeft,
    PageFotterAreaRight,
    PageMainArea,
} from '../../../components/shared/hoc/withAdminPageTemplate'
import {AdminPrimaryButton} from '../../../styledComponents/adminPage/Buttons'
import {BackLink} from '../../../styledComponents/adminPage/Links'
import {StyledTableCaption, TableRowName} from '../../../styledComponents/adminPage/Table'
import PPTextField from '../../../components/shared/forms/PPTextField'
import PPDatePicker from '../../../components/shared/forms/PPDatePicker'
import EventEmitterExAdmin from '../../../components/shared/pageBaseComponents/EventEmitterExAdmin'
import {getYearAfterNextDate, getYearDate} from '../../common/util/Natutil'
import {formatForDateInput, formatForHourInput, formatForMinutesInput} from '../../../formatters/formatDate'
import NatLoginBeforeMessageRepo from './repository/NatLoginBeforeMessageRepo'
import {NatGetLoginBeforeMessage} from './repository/NatGetLoginBeforeMessage'
import {NatPutLoginBeforeMessage, NatPutLoginBeforeMessageParams} from './repository/NatPutLoginBeforeMessage'
import {Location} from 'react-router-dom'

import PPHtmlEditor from '../../../components/shared/forms/PPHtmlEditor'
import PPSelect from '../../../components/shared/forms/PPSelect'
import styled from 'styled-components'
import {StyledDiv, StyledSpan} from '../../../styledComponents/StyledTypeDefinitions'

import {Table, TableBody, TableCell, TableRow} from '@mui/material'
import {SelectChangeEvent} from '@mui/material/Select'

interface LocationState {
    registrationDate: string
}

interface Props {
    loginBeforeMessageMasterId: string
    loginBeforeMessageRepo: NatLoginBeforeMessageRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    eventEmitter: EventEmitterExAdmin
    location: Location<LocationState>,
}

interface States {
    loginBeforeMessageMasterVersion: number
    inputItemTitle: string
    inputItemMessage: string
    inputItemPublishStartDate: string
    inputItemPublishStartHour: string
    inputItemPublishStartMinute: string
    inputItemPublishEndDate: string
    inputItemPublishEndHour: string
    inputItemPublishEndMinute: string
    publishStartDateMin: string
    publishStartDateMax: string
    publishEndDateMin: string
    publishEndDateMax: string
    isLoadCompleted: boolean
    selectedMaxDateTime: string

}

class NatAdminLoginBeforeMessageEditPage extends Component<Props & AdminPagePropsSet, States> {


    constructor(props: Props & AdminPagePropsSet) {
        super(props)


        this.state = {
            loginBeforeMessageMasterVersion: 0,
            inputItemTitle: '',
            inputItemMessage: '',
            inputItemPublishStartDate: '',
            inputItemPublishStartHour: '0',
            inputItemPublishStartMinute: '0',
            inputItemPublishEndDate: '',
            inputItemPublishEndHour: '0',
            inputItemPublishEndMinute: '0',
            publishStartDateMin: '',
            publishStartDateMax: '',
            publishEndDateMin: '',
            publishEndDateMax: '',
            isLoadCompleted: false,
            selectedMaxDateTime: '',
        }

        this.handleRegisterOkClick = this.handleRegisterOkClick.bind(this)
        this.handleRegisterCancelClick = this.handleRegisterCancelClick.bind(this)
        this.onChangeInputItemTitle = this.onChangeInputItemTitle.bind(this)
        this.onChangeInputItemMessage = this.onChangeInputItemMessage.bind(this)
        this.onChangeInputItemPublishStartDate = this.onChangeInputItemPublishStartDate.bind(this)
        this.onChangeInputItemPublishStartHour = this.onChangeInputItemPublishStartHour.bind(this)
        this.onChangeInputItemPublishStartMinute = this.onChangeInputItemPublishStartMinute.bind(this)
        this.onChangeInputItemPublishEndDate = this.onChangeInputItemPublishEndDate.bind(this)
        this.onChangeInputItemPublishEndHour = this.onChangeInputItemPublishEndHour.bind(this)
        this.onChangeInputItemPublishEndMinute = this.onChangeInputItemPublishEndMinute.bind(this)
        this.registerLoginBeforeMessageButton = this.registerLoginBeforeMessageButton.bind(this)
        this.JudgeDispRegisterButton = this.JudgeDispRegisterButton.bind(this)
    }

    async componentDidMount(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        try {

            // 現在日時
            const currentDateTime: Nullable<NatGetCurrentDateTime> = await this.props.asyncCallFunction(
                this.props.currentDateTimeRepo.getCurrentDateTime.bind(this.props.currentDateTimeRepo),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (currentDateTime && currentDateTime.details) {
                const yearAfterNext: string = getYearAfterNextDate(currentDateTime.details.currentDateTime)
                this.setState({
                    selectedMaxDateTime: yearAfterNext,
                    publishStartDateMin: getYearDate(),
                    publishEndDateMax: yearAfterNext,
                })
            }

            // ログイン前メッセージマスタ取得
            const loginBeforeMessage: Nullable<NatGetLoginBeforeMessage> = await this.props.asyncCallFunction(
                this.props.loginBeforeMessageRepo.getLoginBeforeMessageMaster.bind(
                    this.props.loginBeforeMessageRepo, this.props.loginBeforeMessageMasterId),
                (httpErrorOrNetworkError) => {
                    this.props.eventEmitter.showHeadingAreaMessage(httpErrorOrNetworkError)
                },
            )
            if (loginBeforeMessage && loginBeforeMessage.details) {
                this.setState({
                    inputItemTitle: loginBeforeMessage.details.title,
                    inputItemMessage: loginBeforeMessage.details.message,
                    inputItemPublishStartDate: formatForDateInput(loginBeforeMessage.details.publishStartDatetime),
                    inputItemPublishStartHour: formatForHourInput(loginBeforeMessage.details.publishStartDatetime),
                    inputItemPublishStartMinute: formatForMinutesInput(loginBeforeMessage.details.publishStartDatetime),
                    inputItemPublishEndDate: formatForDateInput(loginBeforeMessage.details.publishEndDatetime),
                    inputItemPublishEndHour: formatForHourInput(loginBeforeMessage.details.publishEndDatetime),
                    inputItemPublishEndMinute: formatForMinutesInput(loginBeforeMessage.details.publishEndDatetime),
                    loginBeforeMessageMasterVersion: loginBeforeMessage.details.version,
                    publishStartDateMax: formatForDateInput(loginBeforeMessage.details.publishEndDatetime),
                    publishEndDateMin: formatForDateInput(loginBeforeMessage.details.publishStartDatetime),
                })
            }

        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }


    handleRegisterCancelClick(): void {
        this.props.eventEmitter.closeDialog()
    }

    async handleRegisterOkClick(): Promise<void> {
        this.props.eventEmitter.closeDialog()
        await this.props.eventEmitter.showLoading()

        const request: NatPutLoginBeforeMessageParams = {
            loginBeforeMessageId: this.props.loginBeforeMessageMasterId,
            title: this.state.inputItemTitle,
            message: this.state.inputItemMessage,
            publishStartDatetime: '',
            publishEndDatetime: '',
            version: this.state.loginBeforeMessageMasterVersion,
        }

        if (this.state.inputItemPublishStartDate &&
            this.state.inputItemPublishStartHour &&
            this.state.inputItemPublishStartMinute) {
            request.publishStartDatetime = formatForDateInput(this.state.inputItemPublishStartDate) +
                ' ' +
                ('0' + this.getHourLabel(this.state.inputItemPublishStartHour)).slice(-2) +
                ':' +
                ('0' + this.getMinutsLabel(this.state.inputItemPublishStartMinute)).slice(-2) + ':00'
        }

        if (this.state.inputItemPublishEndDate &&
            this.state.inputItemPublishEndHour &&
            this.state.inputItemPublishEndMinute) {
            request.publishEndDatetime = formatForDateInput(this.state.inputItemPublishEndDate) +
                ' ' +
                ('0' + this.getHourLabel(this.state.inputItemPublishEndHour)).slice(-2) +
                ':' +
                ('0' + this.getMinutsLabel(this.state.inputItemPublishEndMinute)).slice(-2) + ':00'
        }

        try {
            const response: Nullable<NatPutLoginBeforeMessage> =
                await this.props.asyncCallFunction(
                    this.props.loginBeforeMessageRepo.putLoginBeforeMessage.bind(
                        this.props.loginBeforeMessageRepo, request,
                    ),
                    async (httpErrorOrNetworkError) => {
                        await httpErrorOrNetworkError.broadcast(this.props.eventEmitter)
                    },
                    {defaultErrorTitle: Messages.EOPCA0002.toString('ログイン前メッセージ')},
                )
            if (response && response.requestError === null) {
                this.props.navigate(`/admin/loginBeforeMessage/${this.props.loginBeforeMessageMasterId}`,
                    {
                        state: {
                            initialMessage: {
                                title: null,
                                messageLevel: MESSAGE_TYPE.INFORMATION,
                                detail: Messages.IOPCC0005.toString('ログイン前メッセージ', this.state.inputItemTitle),
                            },
                        },
                    },
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    onChangeInputItemTitle(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({inputItemTitle: event.target.value})
    }

    onChangeInputItemMessage(value: string): void {
        this.setState({inputItemMessage: value})
    }


    onChangeInputItemPublishStartDate(date: Nullable<Date>): void {
        if (date !== null) {
            this.setState({inputItemPublishStartDate: date.toString(), publishEndDateMin: date.toString()})
        } else {
            this.setState({inputItemPublishStartDate: '', publishEndDateMin: getYearDate()})
        }
    }

    onChangeInputItemPublishStartHour(event: SelectChangeEvent<unknown>): void {
        this.setState({inputItemPublishStartHour: event.target.value as string})
    }

    onChangeInputItemPublishStartMinute(event: SelectChangeEvent<unknown>): void {
        this.setState({inputItemPublishStartMinute: event.target.value as string})
    }

    onChangeInputItemPublishEndDate(date: Nullable<Date>): void {
        if (date !== null) {
            this.setState({inputItemPublishEndDate: date.toString(), publishStartDateMax: date.toString()})
        } else {
            this.setState({inputItemPublishEndDate: '', publishStartDateMax: this.state.selectedMaxDateTime})
        }
    }

    onChangeInputItemPublishEndHour(event: SelectChangeEvent<unknown>): void {
        this.setState({inputItemPublishEndHour: event.target.value as string})
    }

    onChangeInputItemPublishEndMinute(event: SelectChangeEvent<unknown>): void {
        this.setState({inputItemPublishEndMinute: event.target.value as string})
    }


    async registerLoginBeforeMessageButton(): Promise<void> {
        await this.props.eventEmitter.showDialog({
                title: '確認',
                errorLevel: Messages.IOPCC0010.errorLevel,
                message: Messages.IOPCC0010.toString('ログイン前メッセージ'),
                buttonProps: [
                    {
                        isDefault: false,
                        buttonLabel: 'キャンセル',
                        buttonHandler: this.handleRegisterCancelClick,
                    },
                    {
                        isDefault: false,
                        buttonLabel: 'OK',
                        buttonHandler: this.handleRegisterOkClick,
                    },
                ],
            },
        )
    }

    JudgeDispRegisterButton(): boolean {
        if (
            this.state.inputItemTitle &&
            this.state.inputItemMessage &&
            this.state.inputItemPublishStartDate &&
            this.state.inputItemPublishStartHour &&
            this.state.inputItemPublishStartMinute &&
            this.state.inputItemPublishEndDate &&
            this.state.inputItemPublishEndHour &&
            this.state.inputItemPublishEndMinute
        ) {
            return true
        } else {
            return false
        }
    }

    getHourLabel(hourValue: string): string {
        const hourLabel = HOURS.codeToEnumConstants(hourValue)
        if (hourLabel) {
            return hourLabel.label
        } else {
            return ''
        }
    }

    getMinutsLabel(minutsValue: string): string {
        const minutsLabel = MINUTS.codeToEnumConstants(minutsValue)
        if (minutsLabel) {
            return minutsLabel.label
        } else {
            return ''
        }
    }


    renderFormTable(): ReactNode {
        return (
            <Table>
                <StyledTableCaption>ログイン前メッセージ情報</StyledTableCaption>
                <TableBody>
                    <TableRow>
                        <TableRowName required>タイトル</TableRowName>
                        <TableCell>
                            <PPTextField
                                InputProps={{
                                    inputProps: {
                                        maxLength: 50,
                                    },
                                }}
                                required
                                fullWidth
                                value={this.state.inputItemTitle}
                                onChange={this.onChangeInputItemTitle}
                                eventKeys={['title']}
                                eventEmitter={this.props.eventEmitter}
                                autoFocus
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName required>メッセージ</TableRowName>
                        <TableCell>
                            <PPHtmlEditor
                                value={this.state.inputItemMessage}
                                onEditorChange={this.onChangeInputItemMessage}
                                eventKeys={['message']}
                                eventEmitter={this.props.eventEmitter}
                            />
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableRowName required>掲載期間</TableRowName>
                        <PublishPeriodTableCell>
                            <TermFlexContainer>
                                <TermWrapper>
                                    <FlexBasis>
                                        <PPDatePicker
                                            onChangeDate={this.onChangeInputItemPublishStartDate}
                                            value={(this.state.inputItemPublishStartDate) ?
                                                new Date(this.state.inputItemPublishStartDate) : null
                                            }
                                            minDate={(this.state.publishStartDateMin) ?
                                                new Date(this.state.publishStartDateMin) : null
                                            }
                                            maxDate={(this.state.publishStartDateMax) ?
                                                new Date(this.state.publishStartDateMax) : null
                                            }
                                            eventEmitter={this.props.eventEmitter}
                                            eventKeys={['publishStartDatetime']}
                                        />
                                    </FlexBasis>
                                    <TimeFlexContainer>
                                        <PPSelect
                                            data={HOURS.values()}
                                            onChange={this.onChangeInputItemPublishStartHour}
                                            eventKeys={['publishStartHour']}
                                            eventEmitter={this.props.eventEmitter}
                                            value={this.state.inputItemPublishStartHour}
                                        />
                                        <div>：</div>
                                        <PPSelect
                                            data={MINUTS.values()}
                                            onChange={this.onChangeInputItemPublishStartMinute}
                                            eventKeys={['publishStartMinute']}
                                            eventEmitter={this.props.eventEmitter}
                                            value={this.state.inputItemPublishStartMinute}
                                        />
                                        <TermTxt>から</TermTxt>
                                    </TimeFlexContainer>
                                </TermWrapper>
                                <TermWrapper>
                                    <FlexBasis>
                                        <PPDatePicker
                                            onChangeDate={this.onChangeInputItemPublishEndDate}
                                            value={(this.state.inputItemPublishEndDate) ?
                                                new Date(this.state.inputItemPublishEndDate) : null
                                            }
                                            minDate={(this.state.publishEndDateMin) ?
                                                new Date(this.state.publishEndDateMin) : null
                                            }
                                            maxDate={(this.state.publishEndDateMax) ?
                                                new Date(this.state.publishEndDateMax) : null
                                            }
                                            eventEmitter={this.props.eventEmitter}
                                            eventKeys={['publishEndDatetime']}
                                        />
                                    </FlexBasis>
                                    <TimeFlexContainer>
                                        <PPSelect
                                            data={HOURS.values()}
                                            onChange={this.onChangeInputItemPublishEndHour}
                                            eventKeys={['publishEndHour']}
                                            eventEmitter={this.props.eventEmitter}
                                            value={this.state.inputItemPublishEndHour}
                                        />
                                        <div>：</div>
                                        <PPSelect
                                            data={MINUTS.values()}
                                            onChange={this.onChangeInputItemPublishEndMinute}
                                            eventKeys={['publishEndMinute']}
                                            eventEmitter={this.props.eventEmitter}
                                            value={this.state.inputItemPublishEndMinute}
                                        />
                                        <TermTxt>まで</TermTxt>
                                    </TimeFlexContainer>
                                </TermWrapper>
                            </TermFlexContainer>
                        </PublishPeriodTableCell>
                    </TableRow>
                </TableBody>
            </Table>
        )
    }

    renderPageFooterArea(): ReactNode {

        return (
            <>
                <PageFotterAreaRight>
                    <AdminPrimaryButton
                        disabled={!this.JudgeDispRegisterButton()}
                        onClick={this.registerLoginBeforeMessageButton}
                    >
                        登録
                    </AdminPrimaryButton>
                </PageFotterAreaRight>
                <PageFotterAreaLeft>
                    <BackLink
                        onClick={() => this.props.navigate(
                            `/admin/loginBeforeMessage/${this.props.loginBeforeMessageMasterId}`,
                        )}
                    >
                        ログイン前メッセージ詳細へ戻る
                    </BackLink>
                </PageFotterAreaLeft>
            </>
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }
        return (
            <>
                <PageMainArea>
                    <form>
                        {this.renderFormTable()}
                    </form>
                </PageMainArea>
                <PageFooterArea>
                    {this.renderPageFooterArea()}
                </PageFooterArea>
            </>

        )
    }
}

export const PublishPeriodTableCell = styled(TableCell)`
  &.MuiTableCell-root {
    white-space: nowrap;
  }
`

export default createAdminPage(NatAdminLoginBeforeMessageEditPage)

const TermFlexContainer: StyledDiv = styled.div`
  display: flex;
  align-items: center;
`

const TimeFlexContainer = styled(TermFlexContainer)`
  padding-bottom: 4px;
  padding-left: 15px;
  flex: 1 0 0%;
`

const TermWrapper: StyledDiv = styled.div`
  display: flex;
  flex: 1 1 auto;
  align-items: flex-end;
`

const TermTxt: StyledSpan = styled.span`
  padding: 0 5px 0 5px;
`

const FlexBasis: StyledDiv = styled.div`
  flex: 1 1 0%;
`
